import React from "react";
import Tour, { ReactTourContent } from "../theme/tour"; 

export default props => (
  <Tour
    badgeVerbose
    steps={[
      {
        selector: "#select-plan",
        content: ({ goTo, inDOM, step }) => (
          <ReactTourContent
            title="Selecione o plano"
            goTo={goTo}
            inDOM={inDOM}
            step={step}
          >
            <h2 className="text-center py-2">Estamos quase lá!</h2>
            <h3>Só relembrando que você tem </h3>
            <div className="display-4 text-uppercase text-center">7 dias grátis</div>
            <h4>Para testar o sistema.</h4>
            <h4 className="mt-2">Clique em selecionar</h4>
          </ReactTourContent>
        ),
        position: [100, 40],
        action: node => node.focus()
      }
    ]}
  />
);



// WEBPACK FOOTER //
// ./src/components/tours/plans-tour.jsx